import React from "react";
import { Box } from "@chakra-ui/react";

export default function Logo(props) {
  return (
    <Box {...props}>
      <img src={"https://royalpickupsrc.s3.amazonaws.com/logoblanco.png"} className="logo-royal" alt="logo" />
    </Box>
  );
}